import { Box, Button, Stack } from "@mui/material";
import { TimeIcon } from "@mui/x-date-pickers";
import { MerchantsPageContent } from "Components/Hunter/Merchants/MerchantsList/MerchantsPageContent";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { PlusMathIcon } from "Components/Shared/Icons";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { Link } from "Navigation/Link";
import { appUrl } from "Utils/UrlUtils";
import { Resources, useResource } from "Translations/Resources";
import { useIsCurrentUserAdmin } from "Hooks/useIsCurrentUserAdmin";
import { MerchantListPage } from "Components/Merchants/MerchantListPage";
import { useIsCurrentUserCustomerOnboarding } from "Hooks/useIsCurrentUserCustomerOnboarding";
import { useIsCurrentUserAML } from "Hooks/useIsCurrentUserAml";

const COMPONENT_RESOURCES = Resources.Hunter.Merchants;

const MerchantsPage = () => {
  const isAdmin = useIsCurrentUserAdmin();
  const isCustomerOnboarding = useIsCurrentUserCustomerOnboarding();
  const isAml = useIsCurrentUserAML();
  const { t } = useResource();

  if (isAdmin || isCustomerOnboarding || isAml) {
    return <MerchantListPage />;
  }

  return (
    <AuthenticatedLayout
      title={t(COMPONENT_RESOURCES.Title)}
      backNavigation={{
        mode: "historyStack",
        fallbackUrl: appUrl("dashboard"),
      }}
    >
      {/* override maxWidth, because we want the table wider than the default 600px limit of StyledPageWrapper */}
      <StyledPageWrapper maxWidth="unset !important">
        <Stack gap={4}>
          <Box display="flex" gap={4} rowGap={0} flexWrap="wrap">
            <Button
              component={Link}
              type="button"
              color="primary"
              variant="text"
              to={appUrl("merchant-new-registration")}
              startIcon={<PlusMathIcon width={20} height={20} />}
            >
              {t(COMPONENT_RESOURCES.AddNew)}
            </Button>
            <Button
              component={Link}
              type="button"
              color="primary"
              variant="text"
              to={appUrl("merchant-open-registrations")}
              startIcon={<TimeIcon width={20} height={20} />}
            >
              {t(COMPONENT_RESOURCES.OpenRegistrations.Title)}
            </Button>
          </Box>
          <MerchantsPageContent />
        </Stack>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};

export default MerchantsPage;
